import {
  Box,
  IconButton,
  Stack,
  TextField,
  Tooltip
} from '@mui/material';
import { GridToolbarColumnsButton, GridToolbarFilterButton } from '@mui/x-data-grid';
import { Close, Delete, Magnify } from 'mdi-material-ui';
import toast from 'react-hot-toast';
import { apiService } from '../../api/axiosClient';


const ActivityToolbar = props => {
  const { numSelected, selected, setReload } = props;

  const DeleteActivity = () => {
    selected.forEach(async item => {
      try {
        const response = await apiService.delete(`/activity/${item.id}`);
        toast.success('삭제되었습니다.');
        setReload(reload => reload + 1);
      } catch (error) {
        console.error('Error deleting activity:', error);
      }
    })
  }

  return (
    <Box
      sx={{
        p: 2,
        pb: 0,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        justifyContent: 'space-between'
      }}
    >
      <Box>
        <GridToolbarColumnsButton />        
        <GridToolbarFilterButton />
      </Box>
      <Box sx={{ display: 'flex' }}>
        {numSelected > 0 ? (
          <Stack direction="row" spacing={2} sx={{ pr: 4 }}>
            <Tooltip title='Delete'>
              <IconButton sx={{ color: '#f44336' }} onClick={DeleteActivity} >
                <Delete />
              </IconButton>
            </Tooltip>
          </Stack>
        ) : null}

        <TextField
          variant='standard'
          value={props.value}
          onChange={props.onChange}
          placeholder='이름 검색'
          InputProps={{
            startAdornment: <Magnify fontSize='small' />,
            endAdornment: (
              <IconButton size='small' title='Clear' aria-label='Clear' onClick={props.clearSearch}>
                <Close fontSize='small' />
              </IconButton>
            )
          }}
          sx={{
            width: {
              xs: 1,
              sm: 'auto'
            },
            m: theme => theme.spacing(1, 0.5, 1.5),
            '& .MuiSvgIcon-root': {
              mr: 0.5
            },
            '& .MuiInput-underline:before': {
              borderBottom: 1,
              borderColor: 'divider'
            }
          }}
        />
      </Box>

    </Box>
  )
}

export default ActivityToolbar
